export default (theme) => ({
  bit: {
    display: 'flex',
    flexDirection: 'column',
  },

  grid: {
    flex: 1,
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '&:nth-child(odd)': {
      borderRight: `1px solid ${theme.palette.graphs.separatorLine}`,
    },

    '&:nth-child(1), &:nth-child(2)': {
      borderBottom: `1px solid ${theme.palette.graphs.separatorLine}`,
    },

    '& span': {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',

      '&:first-child': {
        color: 'rgb(123, 139, 153)',
        fontSize: 13,
        fontWeight: 500,
      },
      '&:nth-child(2)': {
        fontSize: 28,
        fontWeight: 'bold',
        letterSpacing: '-1.75px',
        lineHeight: '28px',
        marginBottom: 8,
      },
      '&:nth-child(3)': {
        fontSize: 11,
      },
    },
  },

  horizontal: {
    '&&': {
      borderBottom: 'none',
      borderRight: `1px solid ${theme.palette.graphs.separatorLine}`,
      padding: 0,
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
});
